module.exports = __webpack_public_path__ + "static/media/youtube-icon.1b6abc68.svg";